const resetForm = ($form) => {
  $form.each((index, form) => {
    form.reset();
    $('[required="required"]', form)
      .parent()
      .removeClass('invalid')
      .addClass('pristine');
  });
  return $form;
};

export default resetForm;
